<template>
	<v-header title="体检报告" :headerLeftStatus="true" />
	<div class="sysMain">
		<div style="height: 35px;" class="sysMainBody">
			<Row>
				<Col span="20"><Button type="info" ghost @click="this.view.showBind= true" size="small"
					icon="md-add">新增</Button>
				<label style="color: #999999;"> 点击新增，绑定家人体检单。</label></Col>
				<Col span="4" >  <Button size="small" type="text" @click="$router.push('/help')" style="color: #2D8CF0;">帮助</Button> </Col>
			</Row>
		</div>
		<Collapse v-show="userList.length>0">
			<Panel v-for="user in userList">
				<Badge :count="user.patientList.length">
					{{user.userInfo.patientName}} &ensp;
				</Badge>
				<template #content>
					<List size="small" class="list">
				<!-- 		<template #header >
								<div>1111</div>
						</template> -->
						<ListItem v-for="item in user.patientList" class="list-item">
							<!-- v-show="item.reportType =='1'" -->
	
							<div style="width: 100%;">
								<div class="list-item-content">
									<ListItemMeta style="width: 75%" :title="item.patient+'&ensp;&ensp;'+'&ensp;&ensp;'" />
									<div v-show="item.reportType == '1'" style="width: 20.5%;display: flex;">
										<div v-show="item.hasReport">
											<Button type="text" style="color:#2D8CF0;padding: 0px;" @click="addressPDF(item)">
												报告地址
											</Button>
										</div>
									<!-- 	<div v-show="item.hasReport" style="margin-left: 6px;">
											<Button type="text" style="color:#2D8CF0;padding: 0px;"
												@click="reportViewPDF(item)">
												报告下载
											</Button>
										</div>-->
										<div v-show="!(item?.hasReport)">
											{{'报告未出,无法查看'}}
										</div>
									</div>
								</div>
								<div>
									<div class="child" v-for="item2 in item.examDepartList">
										<div class="child-content">
											&ensp;>&ensp;{{item2.departName}}<label class="child-label">{{  item2?.approved ? '已检' : '未检' }}</label>
											<div class="child-content-item">
												<div class="child-content-item-val" style="width: 70%;" :title="item2.examFeeItemName">
													&ensp;>&ensp;
													{{item2.examFeeItemName}}
												</div>
												 <!-- v-show="item2.approved" -->
												<div style="width: 42%;display: flex;" class="child-content-item-val">
													<div v-show="item2.approved">
														<Button type="text" style="color:#2D8CF0;padding: 0px;" @click="addressPDF(item2)">
															报告地址
														</Button>
													</div>
														<!--<div v-show="item2.approved" style="margin-left: 6px;">
													<Button type="text" style="color:#2D8CF0;padding: 0px;"
															@click="reportViewPDF(item2)">
															报告下载
														</Button>
													</div>-->
													<div v-show="!(item2?.approved)">
														{{'报告未出,无法查看'}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</ListItem>
					
					</List>
			
				</template>
			</Panel>
		</Collapse>
		
		<Drawer title="绑定体检单" v-model="view.showBind" height="100%" :mask-closable="false" placement="bottom">
			<Form ref="formBind" :model="patient" :rules="ruleBind" :label-width="80">
				<FormItem label="体检号" prop="patient">
					<Input v-model="patient.patient" placeholder="请输入"></Input>
				</FormItem>
				<FormItem label="姓名" prop="patientName">
					<Input v-model="patient.patientName" placeholder="请输入"></Input>
				</FormItem>
		
				<FooterToolbar>
					<Button type="primary" ghost icon="md-checkmark" @click="saveBind()">提交</Button>
				</FooterToolbar>
			</Form>
		</Drawer>
		<div style="text-align:center" v-show="view.initComplete===true&&userList.length===0">
			<Result type="warning" title="" desc="没有相关数据"></Result>
		</div>
	</div>
</template>
<style lang="less" scoped>
	.ivu-list-item {
		justify-content: space-between;
	}
	.ivu-list-item-extra {
		display: none;
	}
	.list {
		&-item {
			&-content {
				display: flex;
				justify-content: space-between;
				// &:hover {
				// 	color: aqua;
				// 	cursor: pointer;
				// }
			}
			.child {
				/* all: unset; */
				width: 100%;
				margin-left: 25px;
				margin-bottom: 10px;
				&-label {
					color: coral;
					font-size: 12px;
					margin-left: 6px;
				}
				&-content {
					&-item {
						display: flex;
						margin-left: 10px;
						justify-content: space-between;
						&-val {
							// width: 80%;
							display: inline-block;
							overflow: hidden; 
							white-space: nowrap; 
							text-overflow: ellipsis;
						}
					}
				}
			}
		}
	}

</style>
<script>
	import fileDownload from 'js-file-download'
	import {
		sysPost,
		sysPostWx
	} from '@/utils/api'
	import {
		getToken,
	} from '@/utils/auth'

	import header from "@/components/header/index";
	export default {
		name: 'patient',
		data() {
			return {
				view: {
					loading: false,
					time: {},
					countDown: 60,
					url: '',
					showBind: false,
					showBindList: false,
					initComplete: false,
				},
				userList: [],
				patient: {},
				ruleBind: {
					patient: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					patientName: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					patientPhone: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}]
				}
			};
		},
		created() {
			var token = getToken();
			if (token) this.view.reportUrl = token.viewReportUrl;
			this.userInfoList();
		},
		methods: {
			userInfoList() {
				var that = this;
				sysPost(that, {
					"url": 'Inspect/UserInfoList',
					"data": {}
				}, function(result) {
					that.view.initComplete = true;
					that.userList = result;
				})
			},
			addressPDF(item) {
				var text = this.view.reportUrl + item.reportFilePath;
				this.$copyText(text).then(
					e => {
						this.$Modal.success({
							title: "报告URL复制成功,在浏览器打开",
						});
					},
					e => {
						this.$Message.error('复制失败!');
					}
				)
			},
			reportViewPDF(item) {
				window.location.href = this.view.reportUrl + item.reportFilePath;
			},
			saveBind() {
				
				var that = this;
				this.$refs['formBind'].validate((valid) => {
					console.log(valid);
					if (valid) {
						sysPost(that, {
							"url": 'Inspect/BindPatient',
							"data": {
								"Patient": btoa(that.patient.patient),
								"PatientName": that.patient.patientName,
								}
						}, function(result) {
							that.$Message.success('绑定成功!');
							that.patient = {};
							that.view.showBindList = false;
							that.userInfoList();
						})
					}
				})
			},
		},
		components: {
			"v-header": header
		}
	}
</script>